import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { getWaveRoute } from "@/helpers/navigation.helpers";
import UserCICAndLevel, { UserCICAndLevelSize } from "@/components/user/utils/UserCICAndLevel";
import WinnerDropBadge from "../winner/WinnerDropBadge";
import WaveDropTime from "../time/WaveDropTime";
import type { DropTimestampLayout } from "../drop.types";
interface ParticipationDropHeaderProps {
  readonly drop: ExtendedDrop;
  readonly showWaveInfo: boolean;
  readonly timestampLayout?: DropTimestampLayout | undefined;
}
export default function ParticipationDropHeader(t0) {
  const $ = _c(33);
  const {
    drop,
    showWaveInfo,
    timestampLayout: t1
  } = t0;
  const timestampLayout = t1 === undefined ? "inline" : t1;
  const isStackedTimestamp = timestampLayout === "stacked";
  const authorIdentity = drop.author.handle ?? drop.author.primary_address;
  const hasRank = drop.rank !== null;
  const t2 = isStackedTimestamp ? "tw-flex tw-min-w-0 tw-flex-col tw-items-start tw-gap-y-1" : "tw-flex tw-flex-wrap tw-items-center tw-gap-x-2";
  const t3 = `/${authorIdentity}`;
  let t4;
  if ($[0] !== authorIdentity || $[1] !== t3) {
    t4 = <p className="tw-mb-0 tw-text-md tw-font-semibold tw-leading-none"><Link onClick={_temp} href={t3} className="tw-text-iron-200 tw-no-underline tw-transition tw-duration-300 tw-ease-out hover:tw-text-iron-500">{authorIdentity}</Link></p>;
    $[0] = authorIdentity;
    $[1] = t3;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== drop.author.level) {
    t5 = <UserCICAndLevel level={drop.author.level} size={UserCICAndLevelSize.SMALL} />;
    $[3] = drop.author.level;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== drop.rank || $[6] !== drop.winning_context?.decision_time || $[7] !== hasRank) {
    t6 = hasRank && <WinnerDropBadge rank={drop.rank} decisionTime={drop.winning_context?.decision_time ?? null} />;
    $[5] = drop.rank;
    $[6] = drop.winning_context?.decision_time;
    $[7] = hasRank;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== isStackedTimestamp) {
    t7 = !isStackedTimestamp && <div className="tw-size-[3px] tw-flex-shrink-0 tw-rounded-full tw-bg-iron-600" />;
    $[9] = isStackedTimestamp;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== drop.created_at || $[12] !== isStackedTimestamp) {
    t8 = !isStackedTimestamp && <WaveDropTime timestamp={drop.created_at} />;
    $[11] = drop.created_at;
    $[12] = isStackedTimestamp;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t4 || $[15] !== t5 || $[16] !== t6 || $[17] !== t7 || $[18] !== t8) {
    t9 = <div className="tw-flex tw-flex-wrap tw-items-center tw-gap-x-2 tw-gap-y-1">{t4}{t5}{t6}{t7}{t8}</div>;
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== drop.created_at || $[21] !== isStackedTimestamp) {
    t10 = isStackedTimestamp && <WaveDropTime timestamp={drop.created_at} />;
    $[20] = drop.created_at;
    $[21] = isStackedTimestamp;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== t10 || $[24] !== t2 || $[25] !== t9) {
    t11 = <div className={t2}>{t9}{t10}</div>;
    $[23] = t10;
    $[24] = t2;
    $[25] = t9;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[27] !== drop.wave || $[28] !== showWaveInfo) {
    t12 = showWaveInfo && (() => {
      const waveMeta = (drop.wave as unknown as {
        chat?: {
          scope?: {
            group?: {
              is_direct_message?: boolean | undefined;
            } | undefined;
          } | undefined;
        } | undefined;
      }).chat;
      const isDirectMessage = waveMeta?.scope?.group?.is_direct_message ?? false;
      const waveHref = getWaveRoute({
        waveId: drop.wave.id,
        isDirectMessage,
        isApp: false
      });
      return <Link onClick={_temp2} href={waveHref} className="tw-leading-0 tw-mb-0 tw-text-[11px] tw-text-iron-500 tw-no-underline tw-transition tw-duration-300 tw-ease-out hover:tw-text-iron-300">{drop.wave.name}</Link>;
    })();
    $[27] = drop.wave;
    $[28] = showWaveInfo;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  let t13;
  if ($[30] !== t11 || $[31] !== t12) {
    t13 = <>{t11}{t12}</>;
    $[30] = t11;
    $[31] = t12;
    $[32] = t13;
  } else {
    t13 = $[32];
  }
  return t13;
}
function _temp2(e_0) {
  return e_0.stopPropagation();
}
function _temp(e) {
  return e.stopPropagation();
}